import styled from 'styled-components'
import React from 'react'
import circlepccc from '@/public/assets/icons/circlepcc.svg'

import { NextRouter, withRouter } from 'next/router'
import Link from 'next/link'
import Faded from '@/components/templates/animated/faded'
// import three_lines_horizontal from '@/public/assets/icons/three_lines_horizontal.svg'
import back_circle_navigation from '@/public/assets/icons/back_circle_navigation.svg'
import { motion } from 'framer-motion'
import StatefulHamburgerIcon from '../icons/statefulHamburgerIcon'

type StyledProps = {
    isMainHeaderVisible?: boolean
    hasSubheader?: boolean
    isSubElementActive?: boolean
    index?: number
}

const HeaderWrapper = styled.div<StyledProps>`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    height: 50px;
    -webkit-box-shadow: ${(props) =>
        props.isMainHeaderVisible
            ? '0px 2px 9px -2px rgba(0, 0, 0, 0.2)'
            : 'none'};
    -moz-box-shadow: ${(props) =>
        props.isMainHeaderVisible
            ? '0px 2px 9px -2px rgba(0, 0, 0, 0.2)'
            : 'none'};
    box-shadow: ${(props) =>
        props.isMainHeaderVisible
            ? '0px 2px 9px -2px rgba(0, 0, 0, 0.2)'
            : 'none'};
    padding-left: 20px;
    padding-right: 25px;
    position: fixed;
    top: ${(props) => (props.isMainHeaderVisible ? '0px' : '-52px')};
    transition: all 0.2s;
    left: 0px;
    right: 0px;
    width: 100%;
    z-index: 3;
`

const NavCaption = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`

const Title = styled.div`
    font-family: Lato-Light;
    justify-content: center;
    text-transform: uppercase;
    font-weight: 200;
    color: #0c0c0c;
    font-size: 14px;
    margin-top: 3px;
    letter-spacing: 1.05px;
    transform: translateY(-3px);
`

const DefaultReturnText = styled.div`
    font-family: Lato-light;
    justify-content: center;
    text-transform: lowercase;
    font-weight: 200;
    font-size: 17px;
    margin-top: 2px;
    letter-spacing: 1.05px;
    color: #2a979a;
    transform: translateY(-3px);
`

const CircleLogo = styled.img`
    width: 26px;
    height: 26px;
    margin-right: 10px;
    color: #1e1e1e;
`

// const MenuIcon = styled.img<StyledProps>`
//     height: 20px;
//     width: 20px;
//     background-color: white;

//     transition: top 0.2s;
// `

const MenuIconWrapper = styled(motion.div)`
    position: absolute;
    top: 17px;
    right: 20px;
    padding-left: 10px;
`

interface Props {
    carid?: any
    garageid?: any
    router: NextRouter
    hasReturnIcon?: boolean
    isDefaultReturn?: boolean
    onCrossClick: any
    isOpen: boolean
}

type State = {
    prevScrollPosition: number
    isMainHeaderVisible: boolean
}

class MobileTopHeaderNav extends React.Component<Props, State> {
    state = {
        prevScrollPosition: 0,
        isMainHeaderVisible: true,
    }

    constructor(props: any) {
        super(props)
        this.handleScroll = this.handleScroll.bind(this) //bind function once
    }

    handleScroll = () => {
        const { prevScrollPosition } = this.state
        const currentScrollPos = window.pageYOffset

        const checkVisibility = () => {
            if (currentScrollPos < 10) {
                return true
            }
            if (prevScrollPosition > currentScrollPos) {
                return true
            }
            return false
        }

        return this.setState({
            prevScrollPosition: currentScrollPos,
            isMainHeaderVisible: checkVisibility(),
        })
    }

    componentDidMount() {
        this.setState({ ...this.state, prevScrollPosition: window.pageYOffset })

        window.addEventListener('scroll', this.handleScroll, { passive: true })
        return () => {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, false)
    }

    render() {
        let pathname = this.props.router.pathname

        let link_id = this.props.router.query.link_id
        let car_id = this.props.router.query.car_id
        let image_id = this.props.router.query.image_id

        let returnUrl = (): string => {
            if (car_id) {
                if (image_id) {
                    return `/garage/${link_id}/car/${car_id}/gallery`
                } else {
                    return `/garage/${link_id}/car/${car_id}/overview`
                }
            } else {
                if (image_id) {
                    return `/car/${link_id}/gallery`
                } else if (
                    pathname.includes('gallery') ||
                    pathname.includes('technical-information') ||
                    pathname.includes('history-file')
                ) {
                    return `/car/${link_id}/overview`
                } else {
                    return this.props.router.asPath
                }
            }
        }

        return (
            <>
                <HeaderWrapper
                    id="mobile-header-wrapper"
                    isMainHeaderVisible={this.state.isMainHeaderVisible}
                >
                    <React.Fragment>
                        <NavCaption>
                            <Link
                                href={
                                    this.props.hasReturnIcon
                                        ? returnUrl()
                                        : car_id
                                        ? `/garage/${link_id}`
                                        : this.props.router.asPath
                                }
                            >
                                <a
                                    data-attr={
                                        this.props.hasReturnIcon
                                            ? 'return_arrow'
                                            : 'pcc_logo'
                                    }
                                >
                                    {!this.props.hasReturnIcon && car_id ? (
                                        <CircleLogo
                                            src={back_circle_navigation.src}
                                            alt="return_arrow"
                                        />
                                    ) : (
                                        <CircleLogo
                                            src={
                                                this.props.hasReturnIcon
                                                    ? back_circle_navigation.src
                                                    : circlepccc.src
                                            }
                                            alt="pcc-logo"
                                        />
                                    )}
                                </a>
                            </Link>
                            <Faded>
                                {image_id ? (
                                    <DefaultReturnText>
                                        return
                                    </DefaultReturnText>
                                ) : (
                                    <Title>
                                        {pathname.includes('overview')
                                            ? 'car overview'
                                            : pathname.includes('gallery')
                                            ? 'Gallery'
                                            : pathname.includes(
                                                  'technical-information'
                                              )
                                            ? 'technical information'
                                            : pathname.includes('history-file')
                                            ? 'history file'
                                            : 'garage'}
                                    </Title>
                                )}
                            </Faded>
                        </NavCaption>
                    </React.Fragment>
                    <MenuIconWrapper
                        whileTap={{ scale: 1.1 }}
                        onClick={this.props.onCrossClick}
                        data-attr="hamburger_menu_mobile"
                    >
                        <StatefulHamburgerIcon isOpen={this.props.isOpen} />
                    </MenuIconWrapper>
                </HeaderWrapper>
            </>
        )
    }
}

export default withRouter(MobileTopHeaderNav)
